import { render, staticRenderFns } from "./AdminTeamModal.vue?vue&type=template&id=6e38b8b3&scoped=true"
import script from "./AdminTeamModal.vue?vue&type=script&lang=js"
export * from "./AdminTeamModal.vue?vue&type=script&lang=js"
import style0 from "./AdminTeamModal.vue?vue&type=style&index=0&id=6e38b8b3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e38b8b3",
  null
  
)

export default component.exports